import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  HtmlTrans,
  TextField,
  Typography,
} from 'web-library';
import { usePostReviewAuditReport } from '../../../../api-refactored/reports/usePostReviewAuditReport';
import { stringToSemanticDisplay } from '../../../../utils/DateUtils';
import {
  ErrorObject,
  FormIds,
} from '../../../accessArrangment/components/candidate/SelectCondition/components/SelectConditionContent';

const TextFieldWithRemainingCharacters = ({
  classes,
  value,
  t,
  register,
  onChange,
  maxCharacterCount,
  name,
  label,
  placeholder,
  errMsg,
}: any) => {
  const [remainingCharacter, setRemainingCharacter] = useState(maxCharacterCount);

  useEffect(() => {
    if (value && value !== '') {
      setRemainingCharacter(maxCharacterCount - value.length);
    } else {
      setRemainingCharacter(maxCharacterCount);
    }
  }, [maxCharacterCount, value]);
  const [textFieldFormErrors, setTextFieldFormErrors] = useState<ErrorObject[]>([]);

  useEffect(() => {
    const textFieldErrors: ErrorObject[] = [];
    if (remainingCharacter < 0) {
      textFieldErrors.push({
        id: FormIds.OTHERS_TEXT_AREA_OVER_LIMIT,
        text:
          t('accessArrangement->>SelectCondition.OthersStringExccedError1') +
          (0 - remainingCharacter) +
          t('accessArrangement->>SelectCondition.OthersStringExccedError2'),
      });
    }
    setTextFieldFormErrors(textFieldErrors);
  }, [remainingCharacter, t]);

  const findError = (errorId: string, textformErrors: ErrorObject[]) =>
    textformErrors.find((textformError) => textformError.id === errorId);

  const overLimitError = findError(FormIds.OTHERS_TEXT_AREA_OVER_LIMIT, textFieldFormErrors)?.text;
  const generateHelperText = () => {
    if (overLimitError) {
      return overLimitError;
    }
    return (
      remainingCharacter.toString() + t('accessArrangement->>SelectCondition.CharactersRemaining')
    );
  };
  return (
    <TextField
      name={name}
      className={classes.inputSection}
      multiline
      label={label}
      placeholder={placeholder}
      isRequired
      rows={3}
      helperText={
        <span className={overLimitError ? classes.error : ''}>{generateHelperText()}</span>
      }
      inputRef={register}
      error={errMsg}
      onChange={onChange}
    />
  );
};

const ConfirmReviewModal = ({
  t,
  classes,
  open,
  onCloseModal,
  selectedItem,
  onUpdateSuccess,
}: any) => {
  const [remarks, setRemark] = useState('');

  useEffect(() => {
    setRemark('');
  }, [open]);

  const { mutate: mutateReviewAuditReport, isLoading } = usePostReviewAuditReport({
    onSuccess: (data) => {
      onUpdateSuccess();
    },
    reportId: selectedItem ? selectedItem.uuid : '',
    remarks,
  });
  if (!selectedItem) return <></>;

  return (
    <Dialog open={open} maxWidth="md">
      <>
        <DialogTitle>
          <Typography variant="h4" className={classes.dialogTitle}>
            Confirm Review?
          </Typography>
        </DialogTitle>

        <DialogContent>
          <Typography variant="body1" className={classes.modalDescription}>
            <HtmlTrans
              i18nKey="admin->>AuditReport.ConfirmReviewDescription"
              values={{
                reportDate: stringToSemanticDisplay(dayjs(selectedItem.createdAt).toISOString()),
              }}
            />
          </Typography>
          <TextFieldWithRemainingCharacters
            name="internalRemarks"
            label={t('admin->>AuditReport.RemarksLabel')}
            placeholder={t('admin->>AuditReport.RemarkPlaceholder')}
            maxCharacterCount={200}
            value={remarks}
            t={t}
            classes={classes}
            onChange={(e: any) => {
              setRemark(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Box className={classes.dialogActions}>
            <Button onClick={onCloseModal} variant="text" id="cancel-button">
              {t('common->>Cancel')}
            </Button>
            <Button
              onClick={() => {
                mutateReviewAuditReport();
              }}
              id="update-button"
              disabled={!remarks || remarks.length > 200 || isLoading}
              isLoading={isLoading}
            >
              {t('common->>Update')}
            </Button>
          </Box>
        </DialogActions>
      </>
    </Dialog>
  );
};

export default ConfirmReviewModal;
